import R from 'ramda';
import { reducerWrapper } from '../../main/support/utils'; // TODO, abstract to common  m/support

import { GET_OB_LINK } from '../actions/OnboardingLinkActions';

var INIT_STATE = {
  loading: false,
  error: null,
  data: {}
};

function Handler(state, action) {
  switch (action.type) {
    case GET_OB_LINK.response:
      return R.merge(state, {
        loading: false,
        error: null,
        data: action.data.link
      });

    default:
      return state;
  }
}

const AppReducer = reducerWrapper(INIT_STATE, Handler, {
  request: [GET_OB_LINK],
  error: [GET_OB_LINK],
  resetOn: ['APP_CHANGE']
});

export default AppReducer;
